import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-c62bf7ea")
const _hoisted_1 = { class: "head flex-box jc-sb ai-c" }
const _hoisted_2 = { class: "expired-date" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "ri-close-line ri-xl" }, null, -1)
const _hoisted_4 = { class: "items" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("勉強会のタイトル")
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "ri-pencil-line ri-xl" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "ri-save-3-line ri-xl" }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createTextVNode("受講者人数")
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "ri-pencil-line ri-xl" }, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "ri-save-3-line ri-xl" }, null, -1)
const _hoisted_11 = /*#__PURE__*/_createTextVNode("受講者画面URL")
const _hoisted_12 = { class: "controll-area flex-box jc-sb ai-c" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode("管理画面URL")
const _hoisted_14 = { class: "controll-area flex-box jc-sb ai-c" }
const _hoisted_15 = {
  key: 0,
  class: "comment"
}
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_custom_button = _resolveComponent("custom-button")!
  const _component_heading = _resolveComponent("heading")!
  const _component_text_field = _resolveComponent("text-field")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["hamburger-menu", { 'is-open': _ctx.open }]),
    onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.endEditMode()))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("p", _hoisted_2, " ルームの有効期限：残り" + _toDisplayString(_ctx.calcExpirationDay()), 1),
      _createVNode(_component_custom_button, {
        type: "circle",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
      }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      })
    ]),
    _createElementVNode("ul", _hoisted_4, [
      _createElementVNode("li", null, [
        _createVNode(_component_heading, {
          level: 2,
          fontSize: "m"
        }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        }),
        _createElementVNode("div", {
          class: "controll-area flex-box jc-sb ai-c fw-nw",
          onClick: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["stop"]))
        }, [
          _createVNode(_component_text_field, {
            ref: "roomTitleRef",
            inputVal: _ctx.roomObj.roomTitle,
            "onUpdate:inputVal": _cache[1] || (_cache[1] = ($event: any) => (_ctx.roomObj.roomTitle = $event)),
            type: "text",
            value: _ctx.roomObj.roomTitle,
            readonly: _ctx.isRoomTitleEditMode ? false : true,
            showCopyBtn: !_ctx.isRoomTitleEditMode
          }, null, 8, ["inputVal", "value", "readonly", "showCopyBtn"]),
          (!_ctx.isRoomTitleEditMode)
            ? (_openBlock(), _createBlock(_component_custom_button, {
                key: 0,
                type: "round",
                width: 45,
                height: 45,
                centering: true,
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.editItem('roomTitle')))
              }, {
                default: _withCtx(() => [
                  _hoisted_6
                ]),
                _: 1
              }))
            : (_openBlock(), _createBlock(_component_custom_button, {
                key: 1,
                type: "round",
                width: 45,
                height: 45,
                centering: true,
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.saveItem('roomTitle')))
              }, {
                default: _withCtx(() => [
                  _hoisted_7
                ]),
                _: 1
              }))
        ])
      ]),
      _createElementVNode("li", null, [
        _createVNode(_component_heading, {
          level: 2,
          fontSize: "m"
        }, {
          default: _withCtx(() => [
            _hoisted_8
          ]),
          _: 1
        }),
        _createElementVNode("div", {
          class: "controll-area flex-box jc-sb ai-c fw-nw",
          onClick: _cache[8] || (_cache[8] = _withModifiers(() => {}, ["stop"]))
        }, [
          _createVNode(_component_text_field, {
            ref: "studentNumRef",
            inputVal: _ctx.roomObj.studentNum,
            "onUpdate:inputVal": _cache[5] || (_cache[5] = ($event: any) => (_ctx.roomObj.studentNum = $event)),
            type: "text",
            value: String(_ctx.roomObj.studentNum),
            readonly: _ctx.isStudentNumEditMode ? false : true,
            showCopyBtn: !_ctx.isStudentNumEditMode
          }, null, 8, ["inputVal", "value", "readonly", "showCopyBtn"]),
          (!_ctx.isStudentNumEditMode)
            ? (_openBlock(), _createBlock(_component_custom_button, {
                key: 0,
                type: "round",
                width: 45,
                height: 45,
                centering: true,
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.editItem('studentNum')))
              }, {
                default: _withCtx(() => [
                  _hoisted_9
                ]),
                _: 1
              }))
            : (_openBlock(), _createBlock(_component_custom_button, {
                key: 1,
                type: "round",
                width: 45,
                height: 45,
                centering: true,
                onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.saveItem('studentNum')))
              }, {
                default: _withCtx(() => [
                  _hoisted_10
                ]),
                _: 1
              }))
        ])
      ]),
      _createElementVNode("li", null, [
        _createVNode(_component_heading, {
          level: 2,
          fontSize: "m"
        }, {
          default: _withCtx(() => [
            _hoisted_11
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_12, [
          _createVNode(_component_text_field, {
            type: "text",
            value: _ctx.studentScreenURL,
            readonly: true,
            showCopyBtn: true
          }, null, 8, ["value"])
        ])
      ]),
      _createElementVNode("li", null, [
        _createVNode(_component_heading, {
          level: 2,
          fontSize: "m"
        }, {
          default: _withCtx(() => [
            _hoisted_13
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_14, [
          _createVNode(_component_text_field, {
            type: "text",
            value: _ctx.managedScreenURL,
            readonly: true,
            showCopyBtn: true
          }, null, 8, ["value"]),
          (_ctx.showShareManagedMsg)
            ? (_openBlock(), _createElementBlock("p", _hoisted_15, " パスワード入力をせずに管理画面にログイン可能なURLです。 "))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ], 2))
}